<div *ngIf="!isEmpty(data.rawValue); else text">
	<div *ngFor="let item of data.rawValue | keyvalue">
		<a class="ishares-link text-bold" [href]="item.value.ticker | productUrl" target="_blank" [tooltip]="iSharesTooltip" [tooltip-hover]="true">
			{{ item.value.ticker }}
		</a>
		<ng-template #iSharesTooltip>
			<div *ngIf="item.key === 'benchmark'" dcrHTMLKey="ISHARES_IDEA_BEST_FIT_BENCHMARK">Benchmark iShares idea</div>
			<div *ngIf="item.key === 'factor'" dcrHTMLKey="ISHARES_IDEA_BEST_FIT_FACTOR">Factor iShares idea</div>
			<div *ngIf="item.key === 'esg'" dcrHTMLKey="ISHARES_IDEA_BEST_FIT_ESG">Sustainable iShares idea</div>
		</ng-template>
	</div>
</div>
<ng-template #text>
	<span>{{ data.formattedValue }}</span>
</ng-template>
